import React from 'react';
import Clock from 'react-feather/dist/icons/clock';
import { object } from 'prop-types';

import s from './SessionMessage.css';

// Display a warning message
const SessionMessage = ({...props}) => {
    // if sessionTime is less 1 minute, display message
    if (props.sessionTime.m <= 1) {
        return (
            <div className={s.component}>
                <Clock
                    color="#ff9027"
                    size={50}
                    className={s.svg}
                    id="errorMessage"
                />
                <em>
                    This session will expire in less than 1 minute
                </em>
            </div>
        );
    }
    return null;
};

SessionMessage.propTypes = {
    sessionTime: object,
};

export default SessionMessage;
